var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"kt_scrolltop",staticClass:"scrolltop",attrs:{"id":"kt_scrolltop"}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"svg-icon"},[_c('i',{staticClass:"fas fa-arrow-up",staticStyle:{"color":"white"}})])
}]

export { render, staticRenderFns }